import styled from 'styled-components';
import { IThemeProvider } from '../../../../styles/theme';
import { CreateButton } from '../../../CreateSurveyModal/CreateSurveyModal.styles';

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  box-sizing: border-box;
  height: 80px;
  ${({ theme }: IThemeProvider) => `
       padding: 0 ${theme.layout.spacing.centy};
       border: 1px solid ${theme.colors.neutral.primary[30]};
       border-width: 1px 0 0 0;
    `};
`;

export const CancelButton = styled(CreateButton)`
  display: flex;
  align-items: center;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
    border: 2px solid ${theme.colors.primary[100]};
    color: ${theme.colors.primary[100]};
  `};
`;

export const XMarkCont = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;

  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.mikro} 0 0 0;

    svg {
      path {
        fill: ${theme.colors.primary[100]};
      }
    }
  `};
`;
